<template>
  <v-layout mt-6 ml-10 row wrap align-start>
    <v-flex xs12 sm5 md5 lg5 pr-12>
      <v-text-field outlined label="Location name" v-model="kitchen.name" :rules="[rules.required]"/>
    </v-flex>
    <v-flex xs12 sm7 md7 lg7 pr-12>
      <v-text-field outlined label="Full address" v-model="kitchen.address" :rules="[rules.required]"/>
    </v-flex>
  </v-layout>
</template>
<script>
import { StringUtils as Utils } from '../../utils/StringUtils'

export default {
  props: ['kitchen'],
  data () {
    return {
      rules: {
        required: value => Utils.requiredAny(value)
      }
    }
  }
}
</script>
